<template>
  <b-modal
    id="add-or-update-modal"
    :visible="isAddActive"
    centered
    hide-footer
    hide-header
    no-close-on-esc
    no-close-on-backdrop
    size="md"
    @hidden="resetForm"
    @hide="resetForm"
    @change="(val) => $emit('update:is-add-active', val)"
  >
    <template #default="{ hide }">
      <b-overlay :show="loading" class="px-2">
        <div class="d-flex justify-content-between align-items-center content-sidebar-header py-1" style="border-bottom: 1px solid #000000;">
          <h5 class="mb-0" style="font-weight: 400; font-size: 14px; line-height: 160%;">
            Start Consultation
          </h5>

          <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
        </div>

        <validation-observer
          #default="{ handleSubmit }"
          ref="update_modal_form"
        >
          <b-form class="my-1" @submit.prevent="handleSubmit(onUpdate)" @reset.prevent="resetForm">
            <b-alert v-if="errorMessage" variant="danger" :show="true">
              <div class="alert-body font-small-2">
                <b-card-text class="mb-0">
                  {{ errorMessage }}
                </b-card-text>
              </div>
            </b-alert>
        
            <b-row>
              <b-col cols="12" md="12">
                <validation-provider #default="validationContext" name="Doctor" rules="required">
                  <b-form-group>
                    <template #label>
                      <span>Select Doctor or Dietician<span style="color: tomato"> *</span></span>
                    </template>
                    
                    <doctor-select 
                      :value="doctor_id"
                      @change="val => doctor_id = val"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
  
            <!-- Form Actions -->
            <div class="d-flex mt-2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-primary"
                class="mr-2"
                type="submit"
                :disabled="disableForm"
              >
                Start Consultation
              </b-button>

              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-danger"
                @click="hide"
              >
                Cancel
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </b-overlay>
    </template>
  </b-modal>
</template>
      
<script>
import {
  BOverlay, BSidebar, BForm, BFormGroup, BFormInput, 
  BFormTextarea, BFormInvalidFeedback, BButton, BFormSelect,
  BAlert, BCardText, BModal, BRow, BCol, BFormDatepicker
} from 'bootstrap-vue'

import { required } from '@validations'
import { get } from 'lodash';
import { ValidationProvider, ValidationObserver } from 'vee-validate'

import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'

import DoctorSelect from "@core/components/shared/admin/selects/DoctorSelect.vue"
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
   
export default {
  components: {
    BRow,
    BCol,
    BForm,
    BAlert,
    BModal,
    BButton,
    vSelect,
    BOverlay,
    BSidebar,
    BCardText,
    BFormInput,
    BFormGroup,
    BFormSelect,
    BFormTextarea,
    BFormDatepicker,
    BFormInvalidFeedback,

    // Form Validation
    ValidationProvider,
    ValidationObserver,

    DoctorSelect
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddActive',
    event: 'update:is-add-active',
  },
  props: {
    resource: {
      type: String,
      required: true
    },
    isAddActive: {
      type: Boolean,
      required: true,
    },
    appointmentData: {
      type: [Object, null],
      required: false,
      default: () => null
    },
    isReferenced: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      required,
      loading: false,
      errorMessage: "",
      doctor_id: null,
    }
  },
  computed: {
    disableForm(){
      return !this.doctor_id
    },
  },
  methods: {
    async onUpdate(){
      try {
        this.loading = true;
        this.errorMessage = "";

        if (!this.can(`${this.resource}:CanUpdate`)) {
          return
        }

        if (!this.can('consultations:CanAddNew')) {
          return
        }

        const payload = {
          medical_professional_id: this.doctor_id,
        }

        const response = await this.useJwt().mainService.appointments.complete(this.appointmentData.id, payload);
        const id = get(response, 'data.data.id');
        const consultation_data = get(response, 'data.data');

        if (id && consultation_data.consultation_type === 'medical'){
          this.$router.push({
            params: { id },
            name: 'admin-medical-consultation-edit',
          })
        }

        if (id && consultation_data.consultation_type === 'dietary'){
          this.$router.push({
            params: { id },
            name: 'admin-dietary-consultation-edit',
          })
        }

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success!',
            icon: 'CheckCircleIcon',
            variant: 'success',
            text: `Appointment assigned successfully`
          },
        });
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false
      }
    },
    resetForm() {
      if (this.$refs.update_modal_form) {
        this.$refs.update_modal_form.reset()
      }
    },
  }
}
</script>
    
<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
